import { handleActions } from 'redux-actions';
import { push } from "react-router-redux";
import { initialize as initializeForm } from 'redux-form';
import { NotificationManager } from "react-notifications";
import Swal from 'sweetalert2';
import { api } from "api";

const LISTADO_PERSONAL = 'LISTADO_PERSONAL';
const LOADER = 'LOADER';
const MODULO = 'MODULO';
const PAIS = 'PAIS';

const setLoader = loader => ({
    type: LOADER,
    loader,
});

export const listar = () => (dispatch) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = id_emp[5];
    let pais = id_emp[7];
    
    let params = { id, pais };
    dispatch(setLoader(true));
    api.get('/visitador_medico/personal_externo', params).then((response)=>{
        dispatch({ type: LISTADO_PERSONAL, data: response });
    }).catch(()=>{
        NotificationManager.error(
            'Ocurrió un error al listar personal externo',
            'Error',
            2000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
}

export const registroPersonal = () => (dispatch, getStore) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    const data = getStore().form.FormPersonalExternoVM.values;
    let id_empresa = id_emp[5]
    if (data === undefined){
        Swal.fire({
            title: 'Personal externo',
            text: 'Debe de ingresar nombre',
            type: 'error',
        })
    }else{
        if (data.nombre === undefined || data.nombre === null){
            Swal.fire({
                title: 'Personal externo',
                text: 'Debe de ingresar nombre',
                type: 'error',
            })
        }else{
            if (data.puesto === undefined || data.puesto === null){
                Swal.fire({
                    title: 'Personal externo',
                    text: 'Debe de ingresar puesto',
                    type: 'error',
                })
            }else{
                const formData = {
                    nombre: data.nombre,
                    puesto: data.puesto,
                    empresa: id_empresa,
                    id_pais: id_emp[8]
                }
                dispatch(setLoader(true));
                api.post('/visitador_medico/personal_externo/', formData).then(() => {
                    NotificationManager.success(
                        'Personal externo creado',
                        'Exito',
                        3000
                    );
                    let ruta = `/visitador_medico/${id_emp[5]}/personal_externo/${id_emp[8]}`
                    dispatch(push(ruta));
                }).catch((error) => {
                    NotificationManager.error(
                        error.msj,
                        'Error',
                        2000
                    );
                }).finally(() => {
                    dispatch(setLoader(false));
                });
            }
        }
    }
}

export const modificarPersonal = () => (dispatch, getStore) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    const datos = getStore().form.FormPersonalExternoVM.values;
    const id = datos.id;
    const formData = {
        id: id,
        nombre: datos.nombre,
        puesto: datos.puesto,
    }
    dispatch(setLoader(true));
    api.put(`/visitador_medico/personal_externo/${id}/`, formData).then(() => {
        NotificationManager.success(
            'Personal externo modificado correctamente',
            'Exito',
            3000
        );
        let ruta = `/visitador_medico/${id_emp[5]}/personal_externo`
        dispatch(push(ruta));
    }).catch((error) => {
        NotificationManager.error(
            error.msj,
            'Error',
            2000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
}

export const leer = (id) => (dispatch) => {
    dispatch(setLoader(true));
    api.get(`/visitador_medico/personal_externo/${id}`).then((response) => {
        dispatch(initializeForm('FormPersonalExternoVM', response ));
    }).catch((error)=>{
        NotificationManager.error(
            'Ocurrió un error al consultar personal externo',
            'Error',
            2000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });

}

export const getModulo = (id, modulo) => (dispatch) => {
    const params = {id, modulo}
    dispatch(setLoader(true));
    api.get('/modulos/modulo/', params).then((response)=>{
        dispatch({ type: MODULO, modulo: response.modulos });
    }).catch(() => {
        if (error.status === 401){
            NotificationManager.error(
              error.body.msj,
              'Error',
              0
            );
        }
        if (error.status === 400){
            NotificationManager.error(
              'Ocurrió un error en buscar modulo',
              'Error',
              0
            );
        }
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

const eliminar = id => (dispatch) => {
    dispatch(setLoader(true));
    api.eliminar(`/visitador_medico/personal_externo/${id}`).then(() => {
        NotificationManager.success(
            'Personal externo eliminado correctamente',
            'Exito',
            3000
        );
        dispatch(listar());
    }).catch(() => {
        NotificationManager.error(
            'Ocurrió un error al eliminar personal externo',
            'Error',
            0
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
}

export const getPais = (id) => (dispatch) => {
    dispatch(setLoader(true));
    api.get(`/pais_colaborador/${id}`).then((response)=>{
        dispatch({ type: PAIS, paisN: response.pais });
    }).catch(() => {
        NotificationManager.error(
            'Ocurrió un error en buscar pais',
            'Error',
            2000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

export const actions = {
    listar,
    registroPersonal,
    modificarPersonal,
    leer,
    getModulo,
    eliminar,
    getPais
};

export const reducers = {
    [LOADER]: (state, { loader }) => {
        return {
            ...state,
            loader,
        };
    },
    [LISTADO_PERSONAL]: (state, { data }) => {
        return {
            ...state,
            data,
        };
    },
    [MODULO]: (state, { modulo }) => {
        return {
            ...state,
            modulo,
        };
    },
    [PAIS]: (state, { paisN }) => {
        return {
            ...state,
            paisN,
        };
    },
};

export const initialState = {
    loader: false,
    modulo: [],
    data: [],
    paisN: ''
};

export default handleActions(reducers, initialState)
 